import {
  loyaltyPromotionAlwaysRecurringSchema,
  loyaltyPromotionMonthlyRecurringSchema,
  loyaltyPromotionNoneRecurringSchema,
  loyaltyPromotionSchema,
  loyaltyPromotionWeeklyRecurringSchema,
} from "@redotech/redo-loyalty-common/loyalty-definition";
import * as z from "zod";

// Create partial update schema by making all fields optional except recurringPattern
const updateLoyaltyPromotionDataSchema = z.union([
  loyaltyPromotionNoneRecurringSchema
    .omit({ _id: true, team: true, createdAt: true, updatedAt: true })
    .partial(),
  loyaltyPromotionAlwaysRecurringSchema
    .omit({ _id: true, team: true, createdAt: true, updatedAt: true })
    .partial(),
  loyaltyPromotionWeeklyRecurringSchema
    .omit({ _id: true, team: true, createdAt: true, updatedAt: true })
    .partial(),
  loyaltyPromotionMonthlyRecurringSchema
    .omit({ _id: true, team: true, createdAt: true, updatedAt: true })
    .partial(),
]);

export const updateLoyaltyPromotion = {
  name: "updateLoyaltyPromotion" as const,
  input: z.object({
    promotionId: z.string(),
    data: updateLoyaltyPromotionDataSchema,
  }),
  output: loyaltyPromotionSchema,
};
